export const colors = {
  red: "#A32929",
  darkGrey: "#010101",
  white: "#FFFFFF",
  black1: "#010101",
  red1: "#A32929",
  black: "#010101",
  // red: "#A32929"
};

export const fonts = {
  titles: "Staatliches",
  body: "Cardo",
  credits: "Roboto",
  header: "Staatliches",
  text: "Cardo"
};
// export const fonts = {};

export const mediaQueries = {
  mobile: "@media screen and (max-width: 700px)",
  notMobile: "@media screen and (min-width: 701px)",
  notTablet: "@media screen and (min-width: 901px)",
  tablet: "@media screen and (max-width: 900px)",
  headOverHeels: "@media screen and (max-width: 1300px",
};
